import { useEffect } from 'react'

export const Sparks = (active: any) => {
  useEffect(() => {
    // console.log(active)
    // document.getElementsByClassName('.photo-anmition').toggleClass('photo-anmition-2  photo-anmition-1')
    // document.getElementsByClassName('.spark1').toggleClass('spark11 spark01')
    // document.getElementsByClassName('.spark2').toggleClass('spark22 spark02')
    // document.getElementsByClassName('.spark3').toggleClass('spark33 spark03')
    // document.getElementsByClassName('.spark4').toggleClass('spark44 spark04')
  }, [active])

  return (
    <>
      <div id="sparkss" className="col-12  position-relative col-md-6 photo-anmition photo-anmition-2">
        <img className="invisible" src="img/sec2-img.png" alt="" />
        <div style={{ top: '20%', left: '33%' }} className="position-absolute">
          <div>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 0 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '20%', bottom: 60 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 70 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 30 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: 40 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 10 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 20 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 30 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 50 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 90 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 60 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 70 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 80 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 40 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 69 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 79 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 89 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 49 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '21%', bottom: 64 }} className="spark1 spark11" />
              <i style={{ top: '28%', bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '23%', top: 84 }} className="spark3 spark33" />
              <i style={{ top: '24%', bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: 64 }} className="spark1 spark11" />
              <i style={{ bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: 84 }} className="spark3 spark33" />
              <i style={{ bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-111%' }} className="spark1 spark11" />
              <i style={{ bottom: '-77%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-91%' }} className="spark3 spark33" />
              <i style={{ bottom: '-81%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-10%' }} className="spark1 spark11" />
              <i style={{ bottom: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-15%' }} className="spark3 spark33" />
              <i style={{ bottom: '-4%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '-10%' }} className="spark1 spark11" />
              <i style={{ top: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '-33%' }} className="spark3 spark33" />
              <i style={{ top: '-44%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i className="spark1 spark11" />
              <i className="spark2 2 spark22 spark02" />
              <i className="spark3 spark33" />
              <i className="spark4 spark44" />
            </span>
          </div>
        </div>
        <div style={{ top: '25%', left: '53%' }} className="position-absolute">
          <div>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 0 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '20%', bottom: 60 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 70 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 30 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: 40 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 10 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 20 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 30 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 50 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 90 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 60 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 70 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 80 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 40 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 69 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 79 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 89 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 49 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '21%', bottom: 64 }} className="spark1 spark11" />
              <i style={{ top: '28%', bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '23%', top: 84 }} className="spark3 spark33" />
              <i style={{ top: '24%', bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: 64 }} className="spark1 spark11" />
              <i style={{ bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: 84 }} className="spark3 spark33" />
              <i style={{ bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-111%' }} className="spark1 spark11" />
              <i style={{ bottom: '-77%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-91%' }} className="spark3 spark33" />
              <i style={{ bottom: '-81%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-10%' }} className="spark1 spark11" />
              <i style={{ bottom: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-15%' }} className="spark3 spark33" />
              <i style={{ bottom: '-4%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '-10%' }} className="spark1 spark11" />
              <i style={{ top: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '-33%' }} className="spark3 spark33" />
              <i style={{ top: '-44%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i className="spark1 spark11" />
              <i className="spark2 2 spark22 spark02" />
              <i className="spark3 spark33" />
              <i className="spark4 spark44" />
            </span>
          </div>
        </div>
        <div style={{ top: '40%', left: '45%' }} className="position-absolute">
          <div>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 0 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '20%', bottom: 60 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 70 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 30 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: 40 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 10 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 20 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 30 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 50 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 90 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 60 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 70 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 80 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 40 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 69 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 79 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 89 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 49 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '21%', bottom: 64 }} className="spark1 spark11" />
              <i style={{ top: '28%', bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '23%', top: 84 }} className="spark3 spark33" />
              <i style={{ top: '24%', bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: 64 }} className="spark1 spark11" />
              <i style={{ bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: 84 }} className="spark3 spark33" />
              <i style={{ bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-111%' }} className="spark1 spark11" />
              <i style={{ bottom: '-77%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-91%' }} className="spark3 spark33" />
              <i style={{ bottom: '-81%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-10%' }} className="spark1 spark11" />
              <i style={{ bottom: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-15%' }} className="spark3 spark33" />
              <i style={{ bottom: '-4%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '-10%' }} className="spark1 spark11" />
              <i style={{ top: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '-33%' }} className="spark3 spark33" />
              <i style={{ top: '-44%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i className="spark1 spark11" />
              <i className="spark2 2 spark22 spark02" />
              <i className="spark3 spark33" />
              <i className="spark4 spark44" />
            </span>
          </div>
        </div>
        <div style={{ top: '60%', left: '50%' }} className="position-absolute">
          <div>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 0 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '20%', bottom: 60 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 70 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 30 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: 40 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 10 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 20 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 30 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 50 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 90 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 60 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 70 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 80 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 40 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 69 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 79 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 89 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 49 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '21%', bottom: 64 }} className="spark1 spark11" />
              <i style={{ top: '28%', bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '23%', top: 84 }} className="spark3 spark33" />
              <i style={{ top: '24%', bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: 64 }} className="spark1 spark11" />
              <i style={{ bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: 84 }} className="spark3 spark33" />
              <i style={{ bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-111%' }} className="spark1 spark11" />
              <i style={{ bottom: '-77%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-91%' }} className="spark3 spark33" />
              <i style={{ bottom: '-81%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-10%' }} className="spark1 spark11" />
              <i style={{ bottom: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-15%' }} className="spark3 spark33" />
              <i style={{ bottom: '-4%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '-10%' }} className="spark1 spark11" />
              <i style={{ top: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '-33%' }} className="spark3 spark33" />
              <i style={{ top: '-44%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i className="spark1 spark11" />
              <i className="spark2 2 spark22 spark02" />
              <i className="spark3 spark33" />
              <i className="spark4 spark44" />
            </span>
          </div>
        </div>
        <div style={{ top: '50%', left: '35%' }} className="position-absolute">
          <div>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 0 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '20%', bottom: 60 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 70 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 30 }} className="spark1 spark11" />
              <i style={{ bottom: '20%', top: 40 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: 40 }} className="spark3 spark33" />
              <i style={{ bottom: '20%', top: 10 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 20 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 30 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 50 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 90 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 60 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 70 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 80 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 40 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '20%', bottom: 69 }} className="spark1 spark11" />
              <i style={{ top: '20%', bottom: 79 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '20%', top: 89 }} className="spark3 spark33" />
              <i style={{ top: '20%', bottom: 49 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '21%', bottom: 64 }} className="spark1 spark11" />
              <i style={{ top: '28%', bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '23%', top: 84 }} className="spark3 spark33" />
              <i style={{ top: '24%', bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: 64 }} className="spark1 spark11" />
              <i style={{ bottom: 74 }} className="spark2 2 spark22 spark02" />
              <i style={{ top: 84 }} className="spark3 spark33" />
              <i style={{ bottom: 44 }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-111%' }} className="spark1 spark11" />
              <i style={{ bottom: '-77%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-91%' }} className="spark3 spark33" />
              <i style={{ bottom: '-81%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ bottom: '-10%' }} className="spark1 spark11" />
              <i style={{ bottom: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ bottom: '-15%' }} className="spark3 spark33" />
              <i style={{ bottom: '-4%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i style={{ top: '-10%' }} className="spark1 spark11" />
              <i style={{ top: '-22%' }} className="spark2 2 spark22 spark02" />
              <i style={{ top: '-33%' }} className="spark3 spark33" />
              <i style={{ top: '-44%' }} className="spark4 spark44" />
            </span>
            <span className="sparks">
              <i className="spark1 spark11" />
              <i className="spark2 2 spark22 spark02" />
              <i className="spark3 spark33" />
              <i className="spark4 spark44" />
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
